The capabilities of the requesting partner to act on behalf of a hirer.

This provides a read-only view of the configuration of a SEEK hirer for the current partner.
